import { combineReducers } from 'redux';

import { analyticsReducer } from './analytics';
import { chatModalReducer } from './chatModal';
import { crossLinksReducer } from './crossLinks';
import { desktopListingReducer } from './desktopListing';
import { emptyListingSuggestionsReducer } from './emptyListingSuggestions';
import { experimentsReducer } from './experiments';
import { jsonQueryReducer } from './filters';
import { datesModalReducer } from './filters/datesModalReducer';
import { tagsReducer } from './filters/tags';
import { filtersUrlReducer } from './filtersUrl';
import { hiddenObjectsReducer } from './hiddenObjects';
import { journalHighlightsReducer } from './journalHighlights';
import { lastActionReducer } from './lastAction';
import { listingModalReducer } from './listingModal';
import { listingOffersReducer } from './listingOffers';
import { listingUrlReducer } from './listingUrl';
import { nonGeoParametersReducer } from './nonGeoParameters';
import { nonGeoQueryStringReducer } from './nonGeoQueryString';
import { notificationsReducer } from './notifications';
import { offersCountReducer } from './offersCount';
import { offersSuggestionsReducer } from './offersSuggestions';
import { platformReducer } from './platform';
import { previewOffersReducer } from './previewOffers';
import { queryStringReducer } from './queryString';
import { regionReducer } from './region';
import { regionIdReducer } from './regionId';
import { regionsReducer } from './regions';
import { resultsReducer } from './results';
import { seoTabsLinksReducer } from './seoTabsLinks';
import { seoUrlReducer } from './seoUrl';
import { specialPromosReducer } from './specialPromos';
import { userReducer } from './user';
import { mapReducer } from '../../Map/reducers';
import { IFiltersState } from '../types/filters';
import { IApplicationState, TReduxActions } from '../types/redux';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  analytics: analyticsReducer,
  crossLinks: crossLinksReducer,
  desktopListing: desktopListingReducer,
  experiments: experimentsReducer,
  filters: combineReducers<IFiltersState, TReduxActions>({
    jsonQuery: jsonQueryReducer,
    tags: tagsReducer,
    datesModal: datesModalReducer,
  }),
  filtersUrl: filtersUrlReducer,
  journalHighlights: journalHighlightsReducer,
  lastAction: lastActionReducer,
  listingUrl: listingUrlReducer,
  map: mapReducer,
  nonGeoQueryString: nonGeoQueryStringReducer,
  nonGeoParameters: nonGeoParametersReducer,
  notifications: notificationsReducer,
  offersCount: offersCountReducer,
  queryString: queryStringReducer,
  regionId: regionIdReducer,
  region: regionReducer,
  regions: regionsReducer,
  results: resultsReducer,
  seoUrl: seoUrlReducer,
  seoTabsLinks: seoTabsLinksReducer,
  specialPromos: specialPromosReducer,
  user: userReducer,
  listingOffers: listingOffersReducer,
  hiddenObjects: hiddenObjectsReducer,
  emptyListingSuggestions: emptyListingSuggestionsReducer,
  previewOffers: previewOffersReducer,
  listingModal: listingModalReducer,
  chatModal: chatModalReducer,
  platform: platformReducer,
  offersSuggestions: offersSuggestionsReducer,
});
